export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-500/10 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-mail-send-line text-xs"></i>
            联系我们
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            意见反馈
          </h2>
          <p className="text-foreground-500 text-sm">您的建议是我们进步的动力</p>
        </div>

        <div className="max-w-[640px] mx-auto">
          <form
            data-readdy-form
            className="bg-background-100 rounded-2xl border border-background-300/50 p-6 md:p-8"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground-300 mb-2">
                  您的称呼
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="请输入您的昵称"
                  className="w-full px-4 py-3 rounded-xl bg-background-200/70 border border-background-300/50 text-sm text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-300 mb-2">
                  联系邮箱
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="请输入您的邮箱地址"
                  className="w-full px-4 py-3 rounded-xl bg-background-200/70 border border-background-300/50 text-sm text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-300 mb-2">
                  反馈类型
                </label>
                <select
                  name="type"
                  className="w-full px-4 py-3 rounded-xl bg-background-200/70 border border-background-300/50 text-sm text-foreground-200 focus:outline-none focus:border-primary-500/50 transition-colors cursor-pointer"
                >
                  <option value="">请选择反馈类型</option>
                  <option value="suggestion">功能建议</option>
                  <option value="bug">问题反馈</option>
                  <option value="content">内容推荐</option>
                  <option value="other">其他</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-300 mb-2">
                  详细描述
                </label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  placeholder="请详细描述您的意见或建议（500字以内）"
                  className="w-full px-4 py-3 rounded-xl bg-background-200/70 border border-background-300/50 text-sm text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors resize-none"
                ></textarea>
                <p className="text-foreground-600 text-xs mt-1">最多500字</p>
              </div>

              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />

              <button
                type="submit"
                className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-semibold rounded-xl text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-send-plane-fill mr-2"></i>
                提交反馈
              </button>
            </div>
          </form>

          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-foreground-500">
            <div className="flex items-center gap-2">
              <i className="ri-mail-line text-foreground-400"></i>
              <span>feedback@sihumovies.com</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-customer-service-line text-foreground-400"></i>
              <span>在线客服：工作日 9:00-18:00</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}